<template>
<div id="claims-sources-wrapper">

    <div class="claim-name-wrapper">
        <h2 id="claim-name" >Claim Author: {{claim_source.name}}</h2>
    </div>

    <div class="claim-source-wrapper">
        <component :is="getComponent(claim_source)" 
            :source="claim_source"
            />
    </div>

</div>
</template>

<script>

// import VerticalChart from './Charts/VerticalChart.vue';

/**
 * Lazy load these components cause all we ever need is one so let's only load the one that's needed
 */
const GeneralClaimSource = () => import(/* webpackChunkName: "FactCheckGeneralClaimSource" */ './ClaimSourcesCharts/GeneralClaimSource.vue');

const CandidateSiteClaimSource = () => import(/* webpackChunkName: "FactCheckCandidateSiteClaimSource" */ './ClaimSourcesCharts/CandidateSiteClaimSource.vue');
const GovernmentClaimSource = () => import(/* webpackChunkName: "FactCheckGovernmentClaimSource" */ './ClaimSourcesCharts/GovernmentClaimSource.vue');
const MediaClaimSource = () => import(/* webpackChunkName: "FactCheckMediaClaimSource" */ './ClaimSourcesCharts/MediaClaimSource.vue');
const NonprofitClaimSource = () => import(/* webpackChunkName: "FactCheckNonprofitClaimSource" */ './ClaimSourcesCharts/NonprofitClaimSource.vue');
const ThinkTankClaimSource = () => import(/* webpackChunkName: "FactCheckThinkTankClaimSource" */ './ClaimSourcesCharts/ThinkTankClaimSource.vue');

export default {
    name: 'claim-sources',
    components: {
        // VerticalChart,
        GeneralClaimSource,
        CandidateSiteClaimSource,
        GovernmentClaimSource,
        MediaClaimSource,
        NonprofitClaimSource,
        ThinkTankClaimSource,
    },
    data() {
        return {
            claim_source: {
                name: '',
                slug: '',
            },

            cs: '',
            cs_name: '',
        };
    },
    created(){
        if( this.$route.query.cs ){
            this.cs = this.$route.query.cs;
            this.cs_name = this.$route.query.cs_name;
            this.setClaim();
        }else if( this.$route.params.cs ){
            this.cs = this.$route.params.cs;
            this.cs_name = this.$route.params.cs_name;
            this.setClaim();
        }
    },
    methods: {

        setClaim(){

            let claim = {};

            switch (this.cs) {
                case 'media':
                    claim = {
                        name: 'Media',
                        slug: 'media',
                    };
                    break;
                case 'nonprofit':
                    claim = {
                        name: 'Nonprofit',
                        slug: 'nonprofit',
                    };
                    break;
                case 'think_tank':
                    claim = {
                        name: 'Think Tank',
                        slug: 'think_tank',
                    };
                    break;
                case 'government':
                    claim = {
                        name: 'Government',
                        slug: 'government',
                    };
                    break;
                case 'candidate_site':
                case 'candidate':
                    claim = {
                        name: 'Candidate',
                        slug: 'candidate',
                    };
                    break;

                default:
                    claim = {
                        name: this.cs_name,
                        slug: this.cs,
                    };
            }

            this.$set(this, 'claim_source', claim);
        },

        getComponent(claim){
            let comp = '';
            switch (claim.slug) {
                case 'media':
                    comp = 'media-claim-source';
                    break;
                case 'nonprofit':
                    comp = 'nonprofit-claim-source';
                    break;
                case 'think_tank':
                case 'thinktank':
                    comp = 'think-tank-claim-source';
                    break;
                case 'government':
                    comp = 'government-claim-source';
                    break;
                case 'candidate_site':
                case 'candidate':
                    comp = 'candidate-site-claim-source';
                    break;
            
                default:
                    comp = 'general-claim-source';
                    break;
            }

            return comp;
        },

    },
}
</script>

<style lang="scss">
#claims-sources-wrapper{

    .claim-name-wrapper{
        background-color: #DC0000;
        margin-bottom: -20px;

        #claim-name{
            color: #fff;
            padding: 10px 20px;
        }
    }

}
</style>